import moment from "moment"

export default {
    methods: {

        /*****************************************
         * ステータス名称変換 
         * @param {*} cd 
         * @returns 
         ****************************************/
        getStatusName(cd) {
            var statusName = '';
            switch (cd) {
                case 9:
                    statusName = '回収済み';
                    break;
                case 0:
                    statusName = '未設置';
                    break;
                case 1:
                    statusName = '設置中';
                    break;
                case 2:
                    statusName = '交換依頼中';
                    break;
                case 3:
                    statusName = '撤去依頼中';
                    break;
                default:
                    statusName = '貸出情報なし';
                    break;
            }
            return statusName;
        },
        /*****************************************
         * 廃棄区分名称変換 
         * @param {*} cd 
         ****************************************/
        getDisposName(cd) {
            if (cd == 1) {
                return "廃棄";
            }
            return "";
        },
        /*****************************************
         * 配列が存在するかを確認する
         * @param {エラー配列} val 
         * @returns 
         ****************************************/
        isError: function (val) {
            if (val == undefined)
                return false;
            if (!Array.isArray(val))
                return false;
            if (val.length > 0) {
                return true;
            }
            return false;
        },
        /*****************************************
         * エラーメッセージ表示編集
         * コントロール下に表示するエラーメッセージのフォーマット
         ****************************************/
        dispError: function (val) {
            var err = '';
            for (var key in val) {
                err = err + `<p style="font-size: 13px; color: #ed5b6e;">${val[key]}</p>`
            }
            return err;
        },
        /*****************************************
         * 郵便番号チェック 
         * @param {郵便番号} str 
         * @returns 
         ****************************************/
        isPostCode: function (str) {
            if ( str.match(/^\d{3}-?\d{4}$/) ) {
                return true;
            } 
            return false;
        },
        /*****************************************
         * メールアドレスチェック 
         * @param {文字列}} ymd 
         * @returns 
         ****************************************/
        isMailaddress: function (str) {
            str = (str == null) ? "" : str;
            if (str.match(/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/)) {
                return true;
            } else {
                return false;
            }
        },
        /*****************************************
         * 電話番号ハイフンチェック 
         * @param {文字列}} ymd 
         * @returns 
         ****************************************/
        isTelNoHyphen: function (str) {
            str = (str == null) ? "" : str;
            if(str.match(/[-ー]/)){
                return false;
            }else{
                return true;
            }
        },
        /*****************************************
         * 電話番号チェック 
         * @param {文字列}} ymd 
         * @returns 
         ****************************************/
        isTelNo: function (str) {
            str = (str == null) ? "" : str;
            if (str.match(/^0\d{10,11}$/)) {
                return true;
            } else {
                return false;
            }
        },
        /*****************************************
         * 半角英数チェック 
         * @param {文字列}} ymd 
         * @returns 
         ****************************************/
        isHanEisu: function (str) {
            str = (str == null) ? "" : str;
            if (str.match(/^[A-Za-z0-9]*$/)) {
                return true;
            } else {
                return false;
            }
        },
        /*****************************************
         * 日付のフォーマット 
         * @param {日付} ymd 
         * @returns 
         ****************************************/
        dateFormat: function (ymd) {
            if (ymd === null || !moment(ymd).isValid) {
                return '';
            }

            const date = moment(ymd);
            return date.format('YYYY-MM-DD');
        },
        dateFromToCheck: function (from, to) {

            if (to === null || !moment(to).isValid) {
                return true;
            }
            if (from === null || !moment(from).isValid) {
                return true;
            }
            const toDate = moment(to);
            const fromDate = moment(from);
            if (fromDate > toDate) {
                return false;
            }
            return true;
        },
        /**
         * 数値カンマ編集
         */
        numberFormat: function (price) {
            return price.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
        },
        /**
         * コンテナコードの編集
         */
        contCodeFormat: function (contId) {

            var ptn = /^[0-9]+$/;
            if (ptn.test(contId)) {
                return ('0000000' + contId).slice(-7);
            } else {
                return contId;
            }
        },
        /**
         * 担当者コードの編集
         */
        TantouCodeFormat: function (tantouCd) {

            var ptn = /^[0-9]+$/;
            if (ptn.test(tantouCd)) {
                return ('00000' + tantouCd).slice(-5);
            } else {
                return tantouCd;
            }
        },
        /**
         * Confirm メッセージ表示
         * 「はい」「いいえ」ボタン
         * @param {タイトル} title 
         * @param {メッセージ内容} message 
         * @returns true:はい
         *          false:いいえ 
         */
        swalConfirm: function (title, message) {
            return this.$swal({
                title: title,
                text: message,
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: "はい",
                cancelButtonText: "いいえ"
            }).then((result) => {
                if (result.isConfirmed) {
                    /**はい */
                    return true;
                }
                /**いいえ */
                return false;
            })
        },
        /**
         * アラートメッセージ表示 
         * @param {*} title 
         * @param {*} message 
         * @param {*} icon 
         * @returns 
         */
        swalAlert: function (title, message, icon = "error") {
            return this.$swal({
                title: title,
                text: message,
                icon: icon
            })
        },
        /**
         * トーストメッセージ 
         * @param {*} title 
         * @param {*} icon 
         */
        swalToast: function (title, icon = "success") {
            this.$swal({
                text: title,
                toast: true,
                icon: icon,
                showConfirmButton: false,
                position: 'bottom-end', timer: 3000
            })
        },
        /**
         * 
         * @param {メッセージの内容} mes 
         *     "これは{0}です{1}"
         * @param {埋め込む引数} param 
         *     ["1111","2222"]
         * @returns 
         */
        generateMessage: function (mes, param) {
            let result
            for (let i = 0; i < param.length; i++) {
                let index = "{" + i + "}"
                result = mes.replace(index, param[i])
            }
            return result
        }
    }
};